import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from "../../../adapter-vue";
import {
  TUIGlobal,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import { isUniFrameWork } from "../../../utils/is-uni";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  isHeaderShow: {
    type: Boolean,
    default: true,
  },
  isFooterShow: {
    type: Boolean,
    default: true,
  },
  background: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: "",
  },
  center: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:show", "submit"],
  setup(__props, { emit }) {

const props = __props

const clickType = {
  OUTSIDE: 'outside',
  INSIDE: 'inside'
}


const showDialog = ref(false);
const isHeaderShowDialog = ref(true);
const isFooterShowDialog = ref(true);
const backgroundDialog = ref(true);
const showTitle = ref("");
const isPC = ref(TUIGlobal.getPlatform() === "pc")
const isH5 = ref(TUIGlobal.getPlatform() === "h5");

watchEffect(() => {
  showDialog.value = props.show;
  showTitle.value = props.title;
  isHeaderShowDialog.value = props.isHeaderShow;
  isFooterShowDialog.value = props.isFooterShow;
  backgroundDialog.value = props.background;
})



const toggleView = (type: string) => {
  if (type === clickType.OUTSIDE) {
    close();
  }
};

const close = () => {
  showDialog.value = !showDialog.value;
  emit("update:show", showDialog.value);
}

const submit = () => {
  emit("submit");
  close();
};

return { __sfc: true,clickType, props, showDialog, isHeaderShowDialog, isFooterShowDialog, backgroundDialog, showTitle, isPC, isH5, emit, toggleView, close, submit, TUITranslateService, isUniFrameWork }
}

})